<div class="subExpired" *ngIf="subExpired">
  <h2>Please subscribe to access this content.</h2>
  <a href="{{doi}}">Subscribe Now</a><br/>
  <a class="home" href="/">Go to Home</a>
  </div>
  <ngx-smart-modal #myModal1 identifier="myModal1">
    <h2 class="modalError">Please login and subscribe to access this content.</h2>
    <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
  </ngx-smart-modal>
  <vg-player muted class="testvideo" *ngIf="!loading && videoURL && type == 'VIDEO'">
    <vg-controls [ngClass]="{'fullScreenPlayer': fullScreenMode === true}">
        <vg-play-pause></vg-play-pause>
        <vg-time-display class="currentTime" vgProperty="current" vgFormat="mm:ss"></vg-time-display>
        <div *ngIf="canChangeQuality" class="selectQuality" (click)="selectQuality();">
           {{qualName}}
          <button *ngIf="selectQual && HDQual"  id="hdControl" (click)="watchHD()">HD</button>
          <button *ngIf="selectQual && SDQual"  id="sdControl" (click)="watchSD()">SD</button>
        </div>
        <div class="spacerBlock"></div>
        <vg-mute></vg-mute>
        <vg-volume></vg-volume>
        <vg-fullscreen (click)="fullScreen()"></vg-fullscreen>
        <vg-scrub-bar>
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
      </vg-scrub-bar>
    </vg-controls>
  
    <video *ngIf="!loading" autoplay #media [vgMedia]="media" id="singleVideo" [muted]="muted"  preload="auto" crossorigin>
       <source [src]="videoURL" type="{{videoType}}">
    </video>
  </vg-player>
  <div *ngIf="loading" class="videoloadingBlock">
  <span class="pulsate">LOADING...</span>
  </div>
    <pdf-viewer (pages-initialized)="showGif($event)" class="mobilePDF" *ngIf="videoURL && type == 'PDF'"
    [src]="videoURL"
    [original-size]="false"
    [show-all]="true"
    [zoom]="mobilezoomLevel"
  ></pdf-viewer>
  <pdf-viewer (pages-initialized)="showGif($event)" class="deskPDF" *ngIf="videoURL && type == 'PDF'" [src]="videoURL" [original-size]="false" [zoom-scale]="page-height" [zoom]="zoomLevel" [autoresize]="true"></pdf-viewer>
  <div *ngIf="videoURL" [ngClass]="{'lowerMenu': type == 'VIDEO', 'lowerMenuPDF' : type == 'PDF' }" class="lowerMenu">
    <span *ngIf="!singleChannel && !singleChannelMultiPlay" class="backBut"  routerLink="/playlist/{{videoMeta.channelID}}/{{videoMeta.playlistID}}/videos"> <i class="fas fa-fw fa-arrow-left"></i></span>
    <span *ngIf="singleChannel || singleChannelMultiPlay" class="backBut"  routerLink="/"> <i class="fas fa-fw fa-arrow-left"></i></span>
    <span class="spacer"></span>
    <span *ngIf="videoURL && type == 'PDF'"  style="cursor: pointer;"  (click)="zoomOut()"  title="Zoom Out" ><i class="far fa-fw fa-minus-square"></i></span>
    <span *ngIf="videoURL && type == 'PDF'"  style="cursor: pointer;"  (click)="zoomIn()"  title="Zoom Out" ><i class="far fa-fw fa-plus-square"></i></span>
    <span  style="cursor: pointer;" *ngIf="!IswatchLater == true" (click)="watchLater(videoMeta.id, videoMeta.playlistID )"  title="Watch Later" ><i class="far fa-fw fa-clock"></i></span>
    <span  style="cursor: pointer;" *ngIf="IswatchLater == true" (click)="unwatchLater(videoMeta.id, videoMeta.playlistID )"  title="Remove from Watch Later" ><i class="fas fa-fw fa-clock"></i></span>
    <span  style="cursor: pointer;" *ngIf="!Isfavourite == true" (click)="favourite(videoMeta.id, videoMeta.playlistID )" title="Add to Favourites"><i class="far fa-fw fa-heart"></i></span>
    <span  style="cursor: pointer;" *ngIf="Isfavourite == true" (click)="unfavourite(videoMeta.id, videoMeta.playlistID )" data-toggle="modal" data-target="#removefromfav" title="UnFavourite"><i class="fas fa-fw fa-heart"></i></span>
    </div>
    <div [ngClass]="fav ? 'show' : 'hide'" id="toast"><div id="img"><i class="fas fa-fw fa-heart"></i></div><div id="desc">Added to Favourites</div></div>
    <div [ngClass]="unfav ? 'show' : 'hide'" id="toast"><div id="img"><i class="far fa-fw fa-heart"></i></div><div id="desc">Removed from Favourites</div></div>
    <div [ngClass]="watchLaterNot ? 'show' : 'hide'" id="toast"><div id="img"><i class="far fa-fw fa-clock"></i></div><div id="desc">Added to Watch Later</div></div>
    <div [ngClass]="unwatchLaterNot ? 'show' : 'hide'" id="toast"><div id="img"><i class="far fa-fw fa-clock"></i></div><div id="desc">Removed from Watch Later</div></div>
    
    
    <div *ngIf="!loading" class="col-md-8">
    <!-- <ul> -->
      <!-- <li *ngFor="let recipient of vidQuality | keyvalue"> -->
        <!-- <span style="color: #333;" *ngIf="recipient.key != 'original' && recipient.key != 'type' && recipient.value != null">  {{recipient.key}} {{recipient.value}}</span> -->
  
      <!-- </li> -->
  <!-- </ul> -->
    <div class="video-desc mb-3">
      <h2>
        <a class="videoTitle">{{videoMeta.title}}</a>
      </h2>
      <p>{{videoMeta.description}}</p>
    </div>
  </div>
  <div *ngIf="!loading" class="col-md-12">
    <app-all-content ></app-all-content>
      <div style="min-height: 150px;"></div>
      </div>
      <div *ngIf="!loading" class="container">
  
  <!-- add to favourites -->
  <div class="modal fade" id="addtofav" role="dialog">
  <div class="modal-dialog">
  
  <!-- Modal content-->
  <div class="modal-content">
  <div class="modal-header">
  <h4 i18n="@@Added to Favourites | Added to Favourites Popup Text" class="modal-title">Added to Favourites</h4><a class="viewlist" data-dismiss="modal"><i _ngcontent-c3="" class="fas fa-fw fa-window-close"></i></a>
  </div>
  <div class="modal-body">
  <h3><a data-dismiss="modal" i18n="@@View your list | View your list text in pop up"class="viewlist" routerLink="/my-list">View your List Here</a></h3>
  </div>
  </div>
  
  </div>
  </div>
  
</div>

  